import { IGivenFeedback } from '../models/feedback'
import { BaseUrl } from './base_url_enum'
import Api, { IApiResponse } from './index'

export const submitFeedback = (user_id: number, relation_number: number, response_type: string, response: string) => Api<IApiResponse<[]>>('POST', 'feedback', BaseUrl.Content,
  {
    user_id,
    relation_number,
    response_type,
    // Bugfix: Ignore response field on the backend if it is empty or null, to avoid validation errors
    response: (response === '' || response === null) ? undefined : response
  }
)
export const getGivenFeedback = () => Api<IApiResponse<IGivenFeedback>>('GET', 'feedback', BaseUrl.Content, undefined, true)
